module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"chart.name":"จำนวน Ticket แบ่งตาม Lot (ตามวันที่เกิดเหตุ ย้อนหลัง 1 ปี) ","chart.summary":"มีจำนวน Ticket ทั้งหมด {total} @:common.ticket.unit"}}')
  delete Component.options._Ctor
}
